export const ConfirmationBalloons = () => {
  return (
    <svg width="80" height="99" viewBox="0 0 80 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_567_6081)">
        <path
          d="M19.1853 49.5352H10.2644L14.7244 39.3203L19.1853 49.5352Z"
          fill="#F8AB53"
          stroke="black"
        />
        <path
          d="M15.0596 13.5C17.8926 13.5 20.5203 15.2355 22.4629 18.1709C24.4029 21.1026 25.6201 25.182 25.6201 29.7129C25.6201 34.2439 24.403 38.3231 22.4629 41.2549C20.5203 44.1904 17.8927 45.9258 15.0596 45.9258C12.2265 45.9257 9.59881 44.1904 7.65625 41.2549C5.71624 38.3231 4.5 34.2438 4.5 29.7129C4.50003 25.182 5.7162 21.1026 7.65625 18.1709C9.5988 15.2355 12.2265 13.5001 15.0596 13.5Z"
          fill="#F8AB53"
          stroke="black"
        />
        <path
          d="M14.5064 49.7969C14.6812 50.6909 15.2106 53.0851 14.8625 55.3893C14.4832 57.8995 11.8646 59.3855 10.2326 62.0872C9.50054 63.2991 9.74154 64.7919 9.95993 65.8405C10.4207 68.0528 13.0876 68.8902 14.6772 71.3384C15.4257 72.4911 15.5653 74.2876 15.3469 76.4327C14.9591 80.2422 12.484 81.293 11.1578 82.6431C10.3976 83.417 10.5357 85.1903 10.7104 86.6889C11.2345 87.5935 12.0313 88.1965 12.8678 88.7951C13.2676 89.0966 13.617 89.3936 14.7712 89.9996"
          stroke="black"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter1_d_567_6081)">
        <path
          d="M44.0588 54.3965H35.0842L39.5715 46.7559L44.0588 54.3965Z"
          fill="#E680E3"
          stroke="black"
        />
        <path
          d="M39.5713 11.5C49.5382 11.5 57.6436 19.824 57.6436 30.123C57.6435 40.422 49.5382 48.7461 39.5713 48.7461C29.6045 48.746 21.5001 40.4219 21.5 30.123C21.5 19.8241 29.6045 11.5001 39.5713 11.5Z"
          fill="#E680E3"
          stroke="black"
        />
        <path
          d="M39.3319 55.1484C39.3866 55.8302 38.5336 57.1986 37.6178 58.0457C37.2169 58.4165 37.0803 59.1001 36.8123 59.7052C36.309 60.8416 37.9832 62.6278 40.5301 66.0771C41.1916 66.973 41.2616 67.7468 41.5031 68.6928C42.0143 70.696 40.1978 71.7016 39.3874 72.7038C38.6982 73.5561 38.7976 74.8117 38.8474 76.1555C38.929 78.3508 40.7772 79.2411 41.4218 80.1396C42.0485 81.0131 42.3352 82.0885 42.3633 83.2757C42.3891 84.361 41.2665 85.4612 40.5953 86.5195C40.1946 87.0969 39.7101 87.6806 39.2281 88.1805C39.0116 88.4194 38.8523 88.6282 38.6881 89.0015"
          stroke="black"
          strokeLinecap="round"
        />
        <ellipse cx="29.8437" cy="20.5627" rx="1.76872" ry="1.73844" fill="white" />
        <ellipse cx="47.5307" cy="20.5627" rx="1.76872" ry="1.73844" fill="white" />
        <ellipse cx="36.9184" cy="33.5978" rx="1.76872" ry="1.73844" fill="white" />
        <ellipse cx="26.3061" cy="31.8595" rx="1.76872" ry="1.73844" fill="white" />
        <ellipse cx="38.6872" cy="24.0392" rx="1.76872" ry="1.73844" fill="white" />
        <ellipse cx="45.7621" cy="41.422" rx="1.76872" ry="1.73844" fill="white" />
        <ellipse cx="31.6122" cy="41.422" rx="1.76872" ry="1.73844" fill="white" />
        <ellipse cx="50.1838" cy="31.8595" rx="1.76872" ry="1.73844" fill="white" />
      </g>
      <g filter="url(#filter2_d_567_6081)">
        <path d="M65.8359 45.5H61.1641L63.5 38.5654L65.8359 45.5Z" fill="#F8D746" stroke="black" />
        <path
          d="M63 0.5C66.3646 0.5 69.4778 2.59829 71.7734 6.12988C74.066 9.65686 75.5 14.5596 75.5 20C75.5 25.4404 74.066 30.3431 71.7734 33.8701C69.4778 37.4017 66.3646 39.5 63 39.5C59.6354 39.5 56.5222 37.4017 54.2266 33.8701C51.934 30.3431 50.5 25.4404 50.5 20C50.5 14.5596 51.934 9.65686 54.2266 6.12988C56.5222 2.59829 59.6354 0.5 63 0.5Z"
          fill="#F8D746"
          stroke="black"
        />
        <path
          d="M63.3457 45.6172C63.9307 47.4451 64.1954 48.6792 63.9573 49.36C63.6161 50.3352 62.6112 51.2981 62.0385 52.294C61.8167 52.6798 61.941 52.9244 62.0701 53.1288C62.3355 53.5492 62.7531 53.814 63.0666 54.0898C63.7596 54.6996 63.3834 56.1349 63.1253 57.4848C62.8982 58.6725 62.3509 60.0522 61.8701 61.8031C61.5601 62.9322 62.568 64.078 63.5451 65.2761C64.2419 66.1304 64.4159 66.9207 64.4718 67.6784C64.5496 68.731 64.345 70.1312 63.8459 71.0019C63.6781 72.3823 63.9705 74.1592 64.268 74.8427C64.3417 75.01 64.4514 75.1563 64.4536 75.1961"
          stroke="black"
          strokeLinecap="round"
        />
        <path
          d="M51.5725 13.4492C52.4638 13.8486 53.2644 14.4015 53.9735 14.8499C54.7601 15.3473 55.9733 15.7568 57.0388 16.0527C58.0826 16.3425 59.2701 16.4373 60.5492 16.5764C62.0704 16.7419 64.257 16.9624 66.1976 16.9472C67.999 16.933 70.1481 16.3485 71.154 16.177C71.9769 16.0367 72.587 15.3926 73.1274 14.9918C73.419 14.7158 73.7288 14.4671 74.0057 14.2674C74.13 14.1593 74.2215 14.0372 74.4083 13.6341"
          stroke="black"
          strokeLinecap="round"
        />
        <path
          d="M50.833 18.3516C51.1705 18.5355 51.8463 19.0875 52.6331 19.7208C53.1988 20.1762 54.0633 20.7202 54.8981 21.109C55.5869 21.4297 56.7426 21.5245 58.6693 21.8329C59.2427 21.9246 59.8887 22.0487 61.4059 22.1874C64.1021 22.4339 66.0544 22.2041 66.6683 22.0968C68.9004 21.7069 70.9229 21.31 71.6168 21.0341C72.3981 20.7233 73.1732 20.2339 73.7284 19.8937C74.1606 19.4314 74.4999 19.0616 74.6996 18.8157C74.8078 18.6918 74.9298 18.5697 75.0556 18.444"
          stroke="black"
          strokeLinecap="round"
        />
        <path
          d="M51 23.5868C51.5789 24.0051 52.0663 24.3949 53.6798 25.0093C55.7156 25.7845 57.6229 26.3246 58.2343 26.4922C58.823 26.6536 59.9991 26.7705 61.3012 26.9394C62.7665 27.1295 65.6437 26.8577 67.9695 26.3271C70.0472 25.853 72.6421 24.5692 73.4254 24.1606C73.9603 23.7838 74.3881 23.42 74.6318 23.2527C74.7545 23.1685 74.8754 23.0855 75 23"
          stroke="black"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_567_6081"
          x="0"
          y="13"
          width="30.1196"
          height="85.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_567_6081" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_567_6081"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_567_6081"
          x="17"
          y="11"
          width="45.1431"
          height="86.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_567_6081" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_567_6081"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_567_6081"
          x="46"
          y="0"
          width="34"
          height="83.6953"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_567_6081" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_567_6081"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
